import type { PlannerCoreApi } from '@inter-ikea-storageone/range';
import type { Range } from '@inter-ikea-storageone/shared/types';
import { getRange } from '@inter-ikea-storageone/shared/utils/queryUtils';
import type { ConfigOptions, LandingPageConfig, PlannerConfig } from './@types';
import type { AppConfig, DefaultModule, GalleryConfig } from '@app/rangeConfig/appConfigUtils';

const appConfigRegistry = {
  aurdal: () => import('./aurdal/appConfig'),
  besta: () => import('./besta/appConfig'),
  billy: () => import('./billy/appConfig'),
  boaxel: () => import('./boaxel/appConfig'),
  bror: () => import('./bror/appConfig'),
  eket: () => import('./eket/appConfig'),
  elvarli: () => import('./elvarli/appConfig'),
  ivar: () => import('./ivar/appConfig'),
  jonaxel: () => import('./jonaxel/appConfig'),
  kallax: () => import('./kallax/appConfig'),
  knoxhult: () => import('./knoxhult/appConfig'),
  ladmakare: () => import('./ladmakare/appConfig'),
  lastare: () => import('./lastare/appConfig'),
  metod: () => import('./metod/appConfig'),
  pax: () => import('./pax/appConfig'),
  platsa: () => import('./platsa/appConfig'),
  smastad: () => import('./smastad/appConfig'),
  trofast: () => import('./trofast/appConfig')
} satisfies Record<Range, () => Promise<DefaultModule<AppConfig>>>;

export const getAppConfig = async (): Promise<AppConfig> =>
  (await appConfigRegistry[getRange()]()).default;

export const getPlannerConfig = async (configOptions: ConfigOptions): Promise<PlannerConfig> =>
  (await getAppConfig()).getPlannerConfig(configOptions);

export const getGalleryConfig = async (): Promise<GalleryConfig> =>
  (await getAppConfig()).getGalleryConfig();

export const getLandingPageConfig = async (): Promise<LandingPageConfig> =>
  (await getAppConfig()).getLandingPageConfig();

export async function loadRangeCoreApi(
  errorReporter: (error: Error) => void
): Promise<PlannerCoreApi> {
  return (await getAppConfig()).loadCoreApi({ errorReporter });
}
